module.exports = __webpack_public_path__ + "static/media/johndeere.bb84bc8d.png";